import app from '../app.first';
import Cookies from 'js-cookie'

app.AcceptCookieFooter = class extends app.Component {

    constructor($this) {
        super($this);
        this.cookieName = '__accepted_cookie_policy__';
	}
    
	onReady() {
        if (Cookies.get(this.cookieName)) {
            this.hide();
        } else {
            this.show();
        }

        this.$el.find('.button-accept').on('click', (evt) => {
            evt.preventDefault();

            Cookies.set(this.cookieName, '1', { expires: 365 });
            this.hide();
        });
    }

    show() {
        this.$el.addClass('show').removeClass('hide');
    }

    hide() {
        this.$el.addClass('hide').removeClass('show');
    }
}